export const ARRAY_STATIC_PAGE = ['terms-and-conditions', 'privacy-policy', 'cookie-policy', 'return-and-refund-policy'];
export const NAME_DOMAIN = 'lovetocrunch.com';